export const navDrawerWidth = 70
